import { createClient as createSupabaseClient } from "@supabase/supabase-js";

/**
 * Capacitor 네이티브 앱 전용 Supabase 클라이언트.
 *
 * 왜 별도 클라이언트인가:
 * - 기본 `@supabase/ssr` 클라이언트는 PKCE flow를 사용하는데, PKCE는 `code_verifier`를
 *   `localStorage`에 저장합니다. SFSafariViewController / Chrome Custom Tabs에서 OAuth가
 *   진행되면 외부 브라우저의 localStorage를 쓰고, 앱으로 돌아와서 `exchangeCodeForSession`을
 *   호출해도 Capacitor WebView의 localStorage에는 code_verifier가 없어 실패합니다.
 * - implicit flow는 액세스 토큰을 URL 해시로 직접 돌려주므로 네이티브 앱에서
 *   `setSession()` 한 번으로 세션을 심을 수 있습니다.
 *
 * 이 클라이언트는 OAuth URL 생성 용도로만 쓰고, 실제 세션 저장은 앱의 메인 `createClient()`
 * (쿠키 기반)가 담당합니다. 따라서 `persistSession: false`, `detectSessionInUrl: false`.
 */
export function createNativeSupabaseClient() {
  return createSupabaseClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        flowType: "implicit",
        persistSession: false,
        detectSessionInUrl: false,
        autoRefreshToken: false,
      },
    }
  );
}
